import script from "./ShapeSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShapeSelector.vue?vue&type=script&setup=true&lang=ts"

import "./ShapeSelector.vue?vue&type=style&index=0&id=6f48dd34&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f48dd34"]])

export default __exports__